import { useObserveSizeContext } from "@pathwright/ui/src/components/observers/ObserveSizeContext"
import { Box, Button, useDisclosure } from "@chakra-ui/react"
import { AugmentationToolbarProps } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import AugmentationToolbarPopover from "@pathwright/ux/src/components/augmentation/AugmentationToolbarPopover"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { Indicator } from "@pathwright/ux/src/components/button/IconButton"
import MenuButton from "@pathwright/ux/src/components/button/MenuButton"
import Link from "@pathwright/ux/src/components/link/Link"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import React from "react"
import { useNotificationsState } from "../../notifications/state/notification-state"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

const HomeAugmentationPopover = React.forwardRef<
  HTMLDivElement,
  AugmentationToolbarProps
>(({ toolbar }, ref) => {
  const { me } = usePathwrightContext()
  const { unreadCount } = useNotificationsState()
  const disclosure = useDisclosure()
  const { t } = useTranslate()

  const { getRectValue } = useObserveSizeContext()
  const alertHeight = getRectValue("alert.height")

  return (
    <Box
      className="HomeAugmentationPopover"
      pos="fixed"
      top={`calc(1rem + ${alertHeight || 0}px)`}
      right="1rem"
      zIndex="overlay"
      minW="2rem"
    >
      {me ? (
        <AugmentationToolbarPopover
          // Passing ref to the PopoverContent for accurate offsetting of the augmentation panel.
          ref={ref}
          toolbar={toolbar}
          disclosure={disclosure}
        >
          <MenuButton
            as="div"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box boxSize="2rem" borderRadius="full">
              <UserAvatar user={me} w="100%" h="100%" />
              {!!unreadCount && !disclosure.open && <Indicator />}
            </Box>
          </MenuButton>
        </AugmentationToolbarPopover>
      ) : (
        <Button
          asChild
          // @ts-expect-error: TODO: get typing correct using chakra typegen https://chakra-ui.com/docs/get-started/cli#chakra-typegen
          variant="blurredLightGray"
          size="sm"
        >
          <Link to="/auth/sign-in/" variant="plain" textDecoration="none">
            <Pathicon icon="avatar-circle" />
            {t("nav.navbar_user.sign_in")}
          </Link>
        </Button>
      )}
    </Box>
  )
})

export default HomeAugmentationPopover
